import {Component, OnInit, Inject, ViewEncapsulation, AfterViewInit, OnDestroy} from '@angular/core';
import {MatDialogRef, MAT_DIALOG_DATA} from '@angular/material';
import {CommonService} from 'src/app/core/services/common.service';
import { Subscription } from 'rxjs';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { DocumentService } from 'src/app/core/services/document.service';

@Component({
  selector: 'app-view-file-img-pdf',
  templateUrl: './view-file-pdf-img.component.html',
  encapsulation: ViewEncapsulation.None
})

export class ViewFilePdfImgComponent implements OnInit, AfterViewInit, OnDestroy {

  filePathBase64: string;
  fileName: string;
  filePath: string;
  authorization: any;
  public language: string;
  subscriptions: Subscription = new Subscription();
  imageURL: SafeResourceUrl;
  constructor(
    private commonService: CommonService,
    private documentService: DocumentService,
    public dialogRef: MatDialogRef<ViewFilePdfImgComponent>,
    private sanitizer: DomSanitizer,
    @Inject(MAT_DIALOG_DATA) public data: any) {
      dialogRef.disableClose = false;
      this.filePath = data.filePath;
      this.fileName = data.fileName;
      if(data.type == 'pdf'){
        this.filePathBase64 = data.filePathBase64;
        this.authorization = {
          Authorization: `Bearer ${sessionStorage.getItem('token')}`
        }
        this.language = localStorage.getItem("__language") || "vi";
      } else {
        this.imageURL = this.sanitizer.bypassSecurityTrustResourceUrl(data.imageURL);
      }
  }

  ngOnInit() {
    if(this.data.type == 'pdf'){
      this.subscriptions.add(
        this.commonService.getCurrentLanguage().subscribe((lang) => {
          if (lang !== this.language) {
            location.reload();
          }
        })
      );
    }
  }

  ngOnDestroy(): void {

  }

  ngAfterViewInit() {

  }
  downloadFile(){
    this.documentService.downLoadFileNegotiate(this.filePath).subscribe(res =>{
      this.downLoadFile(res, 'application/octet-stream', this.fileName)  
    })
  }
  downLoadFile(data: any, type: string, fileName: string) {
    const blob = new Blob([data], {type});
    if (window.top.navigator.msSaveOrOpenBlob) {
      // Store Blob in IE
      window.top.navigator.msSaveOrOpenBlob(blob, fileName);
    } else {
      // Store Blob in others
      const tA = document.body.appendChild(document.createElement('a'));
      tA.href = URL.createObjectURL(blob);
      tA.download = fileName;
      tA.style.display = 'none';
      tA.click();
      tA.parentNode.removeChild(tA);
    }
  }

}
